export enum MenuPin {
  DYNAMIC = 0,
  OPEN = 1,
  CLOSED = 2
}
